export default "__VITE_ASSET__5_OETkMOTUvelB0ycJ6rag__"